import shuffleArray  from "../../shuffleArray";
type PuzzleLine = {
  cipher: string;
  key: string;
  answer: string;
  value: string;
  status: "idle" | "active" | "wrong" | "correct";
};

const createCipher = (word: string, key: string) => {
  const cipher = Array(word.length);

  key.split("").forEach((position, index) => {
    cipher[Number(position) - 1] = word[index];
  });

  return cipher.join("");
};

const createKey = (length: number) => {
  const indexes = Array.from({ length }, (_, index) => String(index + 1));

  const defaultKey = indexes.join("");

  let key;

  do {
    key = shuffleArray(indexes).join("");
  } while (key === defaultKey);

  return key;
};

const createRoundType3 = (words: string[]): PuzzleLine[] => {
  return words.map((word) => {
    const answer = word.trim().toUpperCase();

    const key = createKey(answer.length);

    return {
      answer,
      key,
      cipher: createCipher(answer, key),
      value: "",
      status: "idle",
    };
  });
};

export default createRoundType3;